import { render } from "./IndexCollapse.vue?vue&type=template&id=57ec6cf0"
import script from "./IndexCollapse.vue?vue&type=script&lang=js"
export * from "./IndexCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__